module.exports = __webpack_public_path__ + "media/images/proof_links/colored/myspace-ab82dbd9b7a938de24b4e3b8e96204d3.svg";